export const SET_EXTRATORES = "EXTRATOR/SET_EXTRATORES";
export const SET_EXTRATORESLIST = "EXTRATOR/SET_EXTRATORESLIST";
export const SET_EXTRATOR = "EXTRATOR/SET_EXTRATOR";
export const SET_EXTRATOR_ESTATISTICA = "EXTRATOR/SET_EXTRATOR_ESTATISTICA";
export const SET_MODELO_CONTRAPARTIDAS = "EXTRATOR/SET_MODELO_CONTRAPARTIDAS";
export const SET_PAGINATION = "EXTRATOR/SET_PAGINATION";
export const SET_ODS = "EXTRATOR/SET_ODS";
export const SET_LOADING = "EXTRATOR/SET_LOADING";
